import { AppSettingsDef } from "./AppSettingsDef";
import { CapacitorAccess } from "../capacitor";

export class AppSettingsAccessor implements AppSettingsDef {
    private static _instance: AppSettingsAccessor;

    private constructor() {}

    public static get instance(): AppSettingsAccessor {
        this._instance ??= new AppSettingsAccessor();
        return this._instance;
    }

    private get plugin(): AppSettingsDef | null {
        return CapacitorAccess.plugins?.AppSettings;
    }

    async getConnectionUrl(): Promise<{ url: string }> {
        return this.plugin?.getConnectionUrl();
    }

    async hasConnectionUrl(): Promise<{ hasUrl: boolean }> {
        return this.plugin?.hasConnectionUrl();
    }

    async setConnectionUrl(options: { url: string }): Promise<void> {
        return this.plugin?.setConnectionUrl(options);
    }
}
